import { makeAutoObservable, runInAction } from "mobx";
import type RootStore from "../RootStore";

export class NetworkStore {
  rootStore: RootStore;
  effectiveType = "unknown";
  downlink = 0;
  downlinkMax = 0;
  rtt = 0;
  saveData = false;
  type = "unknown";

  constructor(rootStore: RootStore) {
    makeAutoObservable(this, {
      rootStore: false,
    });

    this.rootStore = rootStore;
    this.initializeNetworkInfo();
  }

  private initializeNetworkInfo() {
    if ("connection" in navigator) {
      const connection = (navigator as any).connection;

      this.updateNetworkInfo(connection);

      // Listen for changes
      connection.addEventListener("change", () => {
        this.updateNetworkInfo(connection);
      });
    }
  }

  private updateNetworkInfo(connection: any) {
    runInAction(() => {
      this.effectiveType = connection.effectiveType || "unknown";
      this.downlink = connection.downlink || 0;
      this.downlinkMax = connection.downlinkMax || 0;
      this.rtt = connection.rtt || 0;
      this.saveData = connection.saveData || false;
      this.type = connection.type || "unknown";
    });
  }

  get connectionQuality() {
    if (this.effectiveType === "4g" && this.downlink > 5) {
      return "excellent";
    } else if (
      this.effectiveType === "4g" ||
      (this.effectiveType === "3g" && this.downlink > 1)
    ) {
      return "good";
    } else if (this.effectiveType === "3g" || this.effectiveType === "2g") {
      return "fair";
    } else if (this.effectiveType === "slow-2g") {
      return "poor";
    }
    return "unknown";
  }

  get isSlowConnection() {
    return (
      this.effectiveType === "slow-2g" ||
      this.effectiveType === "2g" ||
      this.saveData
    );
  }

  get shouldReduceData() {
    return this.saveData || this.isSlowConnection;
  }
}
